export default "__VITE_ASSET__TvujyX7Q__"